import ExamEnhancementSettings from '@/components/exams/ExamEnhancementSettings.vue';
import Swal from 'sweetalert2';

export const defaultExamSettings = () => ({
  automated: false, number_questions: 20, number_easy_questions: 5,
  number_medium_questions: 10, number_hard_questions: 5,
  allow_answer_changes: true, answer_reveal_timing: 'after_submission', personal_duration_minutes: null,
});

export default {
  components: { ExamEnhancementSettings },
  data: () => ({ examSettings: defaultExamSettings(), lesson_ids: [] }),
  methods: {
    enhancementPayload() {
      const settings = { ...this.examSettings };
      if (settings.automated) {
        const scope = this.lesson_ids?.length ? this.lesson_ids : [this.lesson || this.unit || this.chapter || this.branch].filter(Boolean);
        settings.automated_lesson_ids = scope.map(item => Number(item.id ?? item));
      } else {
        for (const field of ['number_questions', 'number_easy_questions', 'number_medium_questions', 'number_hard_questions']) delete settings[field];
      }
      if (!this.duration_required) settings.personal_duration_minutes = null;
      return settings;
    },
    validateEnhancements() {
      const s = this.enhancementPayload();
      let message = '';
      if (s.automated && !s.automated_lesson_ids.length) message = 'اختر موقع الأسئلة في المنهج أولاً.';
      else if (s.automated && (!Number.isInteger(s.number_questions) || s.number_questions < 1 ||
        ['number_easy_questions', 'number_medium_questions', 'number_hard_questions'].some(k => !Number.isInteger(s[k]) || s[k] < 0) ||
        s.number_questions !== s.number_easy_questions + s.number_medium_questions + s.number_hard_questions)) {
        message = 'مجموع الأسئلة السهلة والمتوسطة والصعبة يجب أن يساوي العدد الكلي.';
      } else if (s.personal_duration_minutes !== null && (!Number.isInteger(s.personal_duration_minutes) || s.personal_duration_minutes < 1)) {
        message = 'أدخل مدة شخصية صحيحة بالدقائق.';
      }
      if (message) Swal.fire({ icon: 'warning', title: message });
      return !message;
    },
    appendEnhancements(formData) {
      for (const [key, value] of Object.entries(this.enhancementPayload())) {
        if (Array.isArray(value)) value.forEach(id => formData.append(key + '[]', id));
        else formData.append(key, value === null ? '' : typeof value === 'boolean' ? Number(value) : value);
      }
    },
    async loadEnhancements(exam) {
      const defaults = defaultExamSettings();
      for (const key of Object.keys(defaults)) {
        if (exam[key] !== null && exam[key] !== undefined) defaults[key] = exam[key];
      }
      defaults.automated = !!exam.automated;
      defaults.allow_answer_changes = exam.allow_answer_changes !== false && exam.allow_answer_changes !== 0;
      this.examSettings = defaults;
      if (!exam.automated || !exam.automated_scope?.length) return;
      const scope = exam.automated_scope;
      const first = scope[0];
      this.lesson = null;
      if ('chapter' in this) {
        this.chapter = Number(first.type) === 2 ? first : first.parent;
        await this.fetchLessons();
      } else {
        this.branch = Number(first.type) === 1 ? first : Number(first.type) === 2 ? first.parent : first.parent?.parent;
        if (this.branch) await this.fetchUnits();
        this.unit = Number(first.type) === 2 ? first : Number(first.type) === 3 ? first.parent : null;
        if (this.unit) await this.fetchLessons();
      }
      this.lesson_ids = Number(first.type) === 3 ? scope : [];
      await this.fetchQuestions();
    },
    resetLocation(level) {
      this.lesson = null;
      this.lesson_ids = [];
      if (level === 'branch') { this.unit = null; this.units = []; }
      this.lessons = [];
      if (level === 'branch') this.fetchUnits();
      else this.fetchLessons();
      this.fetchQuestions();
    },
  },
};

